import ActionButton from '../../molecules/ActionButton';
import { dateTime } from '../../../helpers/datetime';

const ExportActionButton = (props) => {
    const { config, checkedItems, filters } = props;

    const mime = {
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        pdf: 'application/pdf',
    };

    const downloadExcel = (data) => {
        const blob = new Blob([data], { type: mime[config.ext || 'xlsx'] });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download =
            (config?.filename || 'exported-excel') +
            ' ' +
            dateTime(new Date(), 'DD-MMM-YYYY__HH-mm');
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <ActionButton
            className='menu-link px-3'
            submitted={downloadExcel}
            payload={{
                ...config.payload,
                ...(config
                    ? {
                          [config.selectedKey]: checkedItems,
                      }
                    : {}),
            }}
            config={{
                type: 'text',
                class: 'info',
                action: {
                    url: config.url,
                    method: config.method || 'GET',
                    responseType: 'arraybuffer',
                    params: filters,
                },
                ...(config?.items
                    ? {
                          form: {
                              title: 'Export',
                              url: config.url,
                              method: config.method || 'POST',
                              items: [
                                  ...config.items,
                                  ...[
                                      config
                                          ? {
                                                type: 'hidden',
                                                name: config.selectedKey,
                                                value: checkedItems,
                                            }
                                          : {},
                                  ],
                              ],
                              responseType: 'arraybuffer',
                          },
                      }
                    : {}),
                label: config?.btn?.text || 'Export',
            }}
        />
    );
};

export default ExportActionButton;
